import React from "react";

export const companyLogo1 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Facebook_-_png_0__1_.png?updatedAt=1685624352896",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Amazon_-_jpeg_0.png?updatedAt=1685624249275",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Apple_-_png_0__1_.png?updatedAt=1685624249085",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Netflix_-_png_0__1_.png?updatedAt=1685624248825",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Google_-_png_0__1_.png?updatedAt=1685624248441",
];
export const companyLogo2 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_340.png?updatedAt=1685624248922",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_343.png?updatedAt=1685624509156",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_344.png?updatedAt=1685624248932",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_345.png?updatedAt=1685624248680",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Paytm_-_jpeg_0.png?updatedAt=1685624248692",
];

export const companyList1 = [
  "https://img.learntube.ai/public-assets/About-us/Stripe_-_png_0.png?updatedAt=1689841721147",
  "https://img.learntube.ai/public-assets/About-us/Netflix_-_png_0.png?updatedAt=1689841784275",
  "https://img.learntube.ai/public-assets/About-us/Twitter__-_png_0.png?updatedAt=1689841630758",
  "https://img.learntube.ai/public-assets/About-us/Spotify_-_png_0.png?updatedAt=1689841851007",
  "https://img.learntube.ai/public-assets/About-us/Expedia_-_png_0.png?updatedAt=1689842162702",
  "https://img.learntube.ai/public-assets/About-us/Apple_-_png_0.png?updatedAt=1689842084926",
  "https://img.learntube.ai/public-assets/About-us/Adobe_-_png_0.png?updatedAt=1689841946750",
  "https://img.learntube.ai/public-assets/About-us/Tata_Consultancy_Services_-_png_0.png?updatedAt=1689842026923",
  "https://img.learntube.ai/public-assets/About-us/Airbnb_-_png_0.png?updatedAt=1689842238525",
  "https://img.learntube.ai/public-assets/About-us/Slack_-_png_0.png?updatedAt=1689842318844",
  "https://img.learntube.ai/public-assets/About-us/Intel_-_png_0.png?updatedAt=1689842367676",
  "https://img.learntube.ai/public-assets/About-us/Figma_-_png_0.png?updatedAt=1689842408135",
];

const BenefitsSection = () => {
  return (
    <div>
      <div className="rounded-xl bg-[#2D4F71] p-4">
        <div className="flex gap-x-6">
          <div className="hidden h-full flex-1 md:block md:w-[50%]">
            <img
              src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206770.png?updatedAt=1694519221181"
              alt="demo certificate"
              className="h-auto w-full"
            />
          </div>
          <div className="hidden flex-1 md:block">
            <p className="font-semibold md:text-sm">
              More Companies Who Recognise This Certificate
            </p>
            <div className="grid w-full gap-3 md:grid-cols-3">
              {companyList1?.map((item, index) => (
                <div className="h-full w-4/5">
                  <img
                    key={index}
                    src={item}
                    alt="company images"
                    width={75}
                    height={44}
                    className="h-full w-full"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="grid gap-3 md:mt-5 md:grid-cols-2">
          <div className="rounded-xl bg-[#16314C] py-2">
            <div className="flex items-center justify-center">
              <div className="mr-2">
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202"
                  alt="spike image"
                />
              </div>
              <p>
                <span className="font-bold text-[#2BBD13]">74%</span> chance of
                getting hired by:
              </p>
            </div>
            <div className="mt-2 mb-1 flex items-center justify-center">
              {companyLogo1.map((item, index) => (
                <div className="mr-2 h-full w-[30px]" key={index}>
                  <img src={item} alt="" className="h-auto w-full" />
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-xl bg-[#16314C] py-2">
            <div className="flex items-center justify-center">
              <div className="mr-2">
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202"
                  alt="spike image"
                />
              </div>
              <p>
                <span className="font-bold text-[#2BBD13]">88% </span>chance of
                getting hired by:
              </p>
            </div>
            <div className="mt-2 mb-1 flex items-center justify-center">
              {companyLogo2.map((item, index) => (
                <div className="mr-2 h-full w-[30px]" key={index}>
                  <img
                    src={item}
                    className="h-auto w-full"
                    alt="company logo"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center justify-center rounded-xl bg-[#16314C] py-2">
            <div className="flex items-center justify-center">
              <div className="mr-2">
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202"
                  alt="spike image"
                />
              </div>
              <p>
                <span className="font-bold text-[#2BBD13]">43%</span> higher pay
                than the average
              </p>
            </div>
            <p className="font-bold"> starting salary</p>
          </div>
          <div className="rounded-xl bg-[#16314C] py-2 text-center">
            <p>
              Personalised learning is{" "}
              <span className="font-bold text-[#2BBD13]">98%</span> more
              effective than normal
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
